module.exports = __webpack_public_path__ + "img/pro_one_1.937061e1.jpg";